export default __webpack_public_path__ + "static/media/Blackhawks.88819c0d.png";